/**
 * Feature Flags Configuration
 * 
 * This file controls which features are enabled/disabled in the application.
* Features are controlled via environment variables (REACT_APP_FEATURE_*).
 * 
 * To enable a feature, set the environment variable to 'true' in your .env file:
 * REACT_APP_FEATURE_KYC_ENABLED=true
 * 
 * Default values are used if environment variables are not set.
 */

// Helper function to parse environment variable as boolean
const getEnvBoolean = (envVar: string | undefined, defaultValue: boolean): boolean => {
  if (envVar === undefined) return defaultValue;
  return envVar.toLowerCase() === 'true';
};

export const FEATURE_FLAGS = {
  // KYC (Know Your Customer) Verification System
  // When enabled: Shows KYC status in header, allows users to submit KYC documents
  // When disabled: Hides all KYC-related UI elements and routes
  // Environment Variable: REACT_APP_FEATURE_KYC_ENABLED
  KYC_ENABLED: getEnvBoolean(process.env.REACT_APP_FEATURE_KYC_ENABLED, false),
  
  // Add more feature flags here as needed
  // EXAMPLE_FEATURE: getEnvBoolean(process.env.REACT_APP_FEATURE_EXAMPLE, false),
} as const;

// Helper function to check if a feature is enabled
export const isFeatureEnabled = (featureName: keyof typeof FEATURE_FLAGS): boolean => {
  return FEATURE_FLAGS[featureName];
};

export default FEATURE_FLAGS;

